import React, { useEffect, useState } from 'react'
import { Tune, KeyboardArrowDown, KeyboardArrowRight, Sort, Close, KeyboardArrowUp, ArrowUpward, ArrowDownward, KeyboardArrowLeft, ArrowLeft, ArrowRight, ArrowBackIos,ArrowForwardIos } from '@mui/icons-material'
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import ProductTiles from '../components/ProductTiles'
import Addproduct from '../components/Addproduct'
import axios from 'axios'
import { Url } from '../services/Constants'
import { Getauth } from '../services/Auth'
import { setHeader } from '../services/Headers'
import { GetUserRole } from '../services/UserRole'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast'

export default function Products() {

    const Navigate = useNavigate()
    const [sort, setSort] = useState(false)
    const [price, setPrice] = useState(false)
    const [addproductActive, setAddproductActive] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [products, setProducts] = useState([]);
    const [categoryName, setCategoryName] = useState("All Products");
    const [sortCriteria, setSortCriteria] = useState('newest');
    const navigate = useNavigate();
    const [variant, setVariant] = useState(false);
    const [filterWithVariants, setFilterWithVariants] = useState(false);
    const [filterWithoutVariants, setFilterWithoutVariants] = useState(false);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [userRole, setUserRole] = useState(GetUserRole());
    const [isSeller, setIsSeller] = useState(false);
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const categoryId = query.get('category_id');
    const [currentSlide, setCurrentSlide] = useState(0);
    const [productCode,setProductCode] = useState();
    const [varientId, setVarientId] = useState()
    const [outofStock,setoutofstock] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");
    const [dataFound, setDataFound] = useState(false);

    const handleSlide = (direction) => {
        if (direction === "prev") {
            setCurrentSlide((prev) => (prev > 0 ? prev - 1 : 5));
        } else if (direction === "next") {
            setCurrentSlide((prev) => (prev < 5 ? prev + 1 : 0));
        }
    };

    const variantHandle = async(e)=>{
        try {
            const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${e.trget.id}&quantity=1`)
            if(result.data.response_code!==200){
            setoutofstock(true)
            }
        } catch (error) {
            console.log(error)
        }
        setProductCode(e.target.innerText);
        setVarientId(e.target.id)
    }

    useEffect(() => {
        const userProfileCheck = async () => {
            if (userRole === "buyer") {
                try {
                    const result = await axios.get(`${Url}/buyer/get_profile`, setHeader());
                    if (result.data.response_code === 200) {
                        setIsSeller(false);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (userRole === "seller") {
                try {
                    const result = await axios.get(`${Url}/seller/get_profile`, setHeader());
                    if (result.data.response_code === 200) {
                        setIsSeller(true);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };

        userProfileCheck();
    }, [userRole]);

    async function getProducts(){
        try {
            let url = userRole === "seller"
                ? `${Url}/seller/products/product_listing?page=${currentPage}`
                : `${Url}/buyer/products/product_listing?page=${currentPage}`;

            // Add price filter based on sort criteria
            if (sortCriteria === 'lowToHigh') {
                url += '&price=low_price';
            } else if (sortCriteria === 'highToLow') {
                url += '&price=high_price';
            }

            if (filterWithVariants) {
                url += '&is_variant=true';
            } else if (filterWithoutVariants) {
                url += '&is_variant=false';
            }

            if (categoryId) {
                url += `&category_id=${categoryId}`;
            }
            if (searchTerm) {
                url += `&name=${searchTerm}`
            }

            const response = await axios.get(url, setHeader());
            let products
            let totalPages

            if (response.data.response_code === 204){
                setDataFound(true)
                products = []
                totalPages = 0
            }else if (response.data.response_code === 200){
                products = response.data.response_data.products
                totalPages = response.data.response_data.total_pages;
                setDataFound(false)
            }else{
                toast.error("something went wrong!")
            }

            let filteredProducts = products;

            setProducts(filteredProducts);
            setTotalPages(totalPages);

            if (categoryId && products.length > 0) {
                setCategoryName(products[0].category_name);
            } else if (products.length === 0) {
                try {
                    const response = await axios.get(`${Url}/categories`);
                    const categories = response.data.response_data.categories;
                    const category = await categories.find(item => item.id === Number(categoryId));
                    if (category) {
                        setCategoryName(category.name);
                    } else {
                        setCategoryName("Category Not Found");
                    }
                } catch (error) {
                    console.error("Error fetching categories:", error);
                    setCategoryName("Error Loading Category");
                }
            } else {
                setCategoryName("All Products");
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };
    

    useEffect(() => {
        getProducts();
    }, [categoryId,currentPage, sortCriteria, filterWithVariants, filterWithoutVariants, userRole, searchTerm]);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const addProductToggle = () => {
        setAddproductActive(!addproductActive)
    }


    const handleSortChange = (criteria) => {
        setSortCriteria(criteria);
        setSort(false);
    };


    const toggleDropdown = (type) => {
        if (type === 'variant') setVariant(!variant);
        if (type === 'price') setPrice(!price);
    };

    const toggleVariantFilter = (type) => {
        if (type === 'with') {
            setFilterWithVariants(!filterWithVariants);
            setFilterWithoutVariants(false);
        } else if (type === 'without') {
            setFilterWithoutVariants(!filterWithoutVariants);
            setFilterWithVariants(false);
        }
    };


    const handleProductClick = async (productId) => {
    // const productDetailsPath = userRole === "seller"
    //   ? `${Url}/seller/products/${productId}`
    //   : `${Url}/buyer/products/${productId}`;

    try {
      // const response = await axios.get(productDetailsPath);

      navigate(`/product-detail/${productId}`);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };




    return (
        <>
            <div className="products-container flex flex-col">
                <div className="products-header">
                    <Navbar setSearch={setSearchTerm} />
                </div>
                <div className="products-feed p-4 min-h-screen">
                    <div className="productsd-feed-top flex justify-between items-center shadow-md pb-3">
                        <div className="products-top-center text-center font-extrabold text-amber-950 text-3xl">
                            <span className="products-center-text cursor-default max-sm:text-xl">
                                {searchTerm ? `Search results for "${searchTerm}"` : categoryName}
                            </span>
                        </div>
                        {isSeller && (
                            <div className="add-product-container cursor-pointer max-sm:text-center mt-4">
                                <span
                                    className="w-full text-white font-bold text-lg bg-amber-950 rounded-md p-2"
                                    onClick={() => Navigate('/addproduct')}
                                >
                                    Add Product
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col md:flex-row md:space-x-4">
                        {/* Mobile Filter Button */}
                        <div className="md:hidden mb-4 flex justify-center">
                            <button
                                className="w-full max-w-[70%] sm:max-w-[60%] text-white font-bold text-lg bg-amber-950 rounded-md p-2 mx-auto"
                                onClick={() => setShowMobileFilters(!showMobileFilters)}
                            >
                                {showMobileFilters ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>

                        {/* Sidebar for Filters */}
                        <div
                            className={`filter-container w-full md:w-1/4 lg:w-1/5 p-2 bg-gray-100 ${
                                showMobileFilters ? 'block' : 'hidden md:block'
                            }`}
                        >
                            <div className="w-full md:w-auto p-4 bg-white rounded-lg shadow-md">
                                <h2 className="text-lg font-bold text-brown-700 mb-4">Filters</h2>

                                {/* VARIANTS */}
                                <div className="mb-4">
                                    <h3
                                        className="flex items-center justify-between text-sm font-semibold text-gray-700 cursor-pointer"
                                        onClick={() => toggleDropdown('variant')}
                                    >
                                        Variants
                                        {variant ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    </h3>
                                    {variant && (
                                        <div className="ml-4 mt-2 space-y-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    checked={filterWithVariants}
                                                    onChange={() => toggleVariantFilter('with')}
                                                />
                                                <span className="text-sm text-gray-600">With Variants</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    checked={filterWithoutVariants}
                                                    onChange={() => toggleVariantFilter('without')}
                                                />
                                                <span className="text-sm text-gray-600">Without Variants</span>
                                            </label>
                                        </div>
                                    )}
                                </div>

                                {/* PRICE RANGE */}
                                <div className="mb-4">
                                    <h3
                                        className="flex items-center justify-between text-sm font-semibold text-gray-700 cursor-pointer"
                                        onClick={() => toggleDropdown('price')}
                                    >
                                        Price
                                        {price ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    </h3>
                                    {price && (
                                        <div className="ml-4 mt-2 space-y-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="priceSort"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    onChange={() => handleSortChange('lowToHigh')}
                                                />
                                                <span className="text-sm text-gray-600">Low to High</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="priceSort"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    onChange={() => handleSortChange('highToLow')}
                                                />
                                                <span className="text-sm text-gray-600">High to Low</span>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Main Content Area */}
                        <div className="w-full md:w-3/4 lg:w-4/5">
                            { !isSeller ?
                                <div className="relative flex items-center justify-center mb-6 overflow-hidden">
                                    {/* Previous Button */}
                                    <button
                                        className="absolute left-0 bg-gradient-to-r from-white via-gray-500 to-amber-950 text-white p-1 rounded-full shadow-md z-10 w-8 h-8 flex items-center justify-center ml-8"
                                        onClick={() => handleSlide("prev")}
                                    >
                                        <ArrowBackIos />
                                    </button>
                                    {/* Slider Content */}
                                    <div className="w-full overflow-hidden">
                                        <div
                                            className="flex transition-transform duration-500"
                                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                                        >
                                            {products.map((product, index) => (
                                                <div key={index} className="flex-shrink-0 w-full p-4 cursor-pointer" onClick={()=>handleProductClick(product.id)}>
                                                    <div className="flex flex-col md:flex-row border rounded-lg shadow-md">
                                                        {/* Image Section */}
                                                        <div className="w-full md:w-1/3 p-4 md:pl-6">
                                                            <img 
                                                                src={product.product_images[0].image} 
                                                                alt={product.name} 
                                                                className="w-full h-auto md:w-56 md:h-56 object-cover rounded-md md:ms-8"
                                                            />
                                                            {/* Dots Navigation */}
                                                            <div className="flex justify-center mt-2 md:mr-24">
                                                                {products.slice(0,6).map((_, dotIndex) => (
                                                                    <div
                                                                        key={dotIndex}
                                                                        className={`h-2 w-2 mx-1 rounded-full cursor-pointer ${currentSlide === dotIndex ? 'bg-amber-950' : 'bg-gray-300'}`}
                                                                        onClick={() => setCurrentSlide(dotIndex)}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {/* Content Section */}
                                                        <div className="w-full md:w-2/3 p-4 bg-white">
                                                            <h3 className="text-lg text-amber-950 font-semibold">{product.name}</h3><br/>
                                                            <p className="text-sm text-gray-600"><strong className="text-amber-950">Category: </strong>{product.category_name}</p><br/>
                                                            <p className="text-sm text-gray-600">{product.specification}</p><br/>
                                                            <span className="text-xl font-bold">
                                                                Rs. {product.product_variants[0].discounted_price}
                                                            </span>
                                                            <span className="ml-1 text-gray-500 line-through">
                                                                {product.product_variants[0].price}
                                                            </span>
                                                            <div className="product-variants mt-4">
                                                                <span className="font-bold text-amber-950 cursor-default">Variants:</span>
                                                                {product.product_variants.length > 0 ? product.product_variants.map((variant) => (
                                                                    <span
                                                                        key={variant.id} id={variant.id}
                                                                        className="ml-3 bg-gray-200 p-1 text-sm font-bold rounded-xl cursor-pointer" 
                                                                        onClick={variantHandle}
                                                                    >
                                                                        {variant.product_code}
                                                                    </span>
                                                                )) : (
                                                                    <span className="ml-3 bg-gray-400 text-amber-950 p-1 text-sm rounded-xl">
                                                                        {product.product_variants[0].product_code}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Next Button */}
                                    <button
                                        className="absolute right-0 bg-gradient-to-r from-white via-gray-500 to-amber-950 text-white p-1 rounded-full shadow-md z-10 w-8 h-8 flex items-center justify-center mr-8"
                                        onClick={() => handleSlide("next")}
                                    >
                                        <ArrowForwardIos />
                                    </button>
                                </div> : ""
                            }
                            <div className="grid">
                               {
                                !dataFound ? 
                                    <ProductTiles
                                    products={products}
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    getProduct={getProducts}
                                /> : 
                                    <div className="text-center">
                                        <p>No products found</p>
                                    </div>
                               }
                            </div>
                        </div>
                    </div>

                    <div className="products-feed-bottom border-b-2 mt-4"></div>
                </div>

                <div className="products-footer ">
                    <Footer />
                </div>
            </div>
            {/*addproductActive ? <Addproduct className="" data={addProductToggle} /> : ""*/}
        </>
    )
}
